export const css = {
    root: '_2FO-_h0W',
    slideIn: '_22IWGRwn',
    slideOut: '_8qbp3rrF',
    underlayVisible: 'iW5_jKgH',
    content: 'ALr6zHrf',
    pane: '_2wT3C_Pi',
    title: '_2lldZMCW',
    titleContent: '_1qpMWO27',
    close: '_1XDUpsEi',
    closeIcon: '_232HBCHI',
    left: '_2y2JM4nd',
    right: '_1Jjw2Xdq',
    top: '_3LgiMHUI',
    bottom: '_2seLPuu9',
    open: '_2dfB8_e1',
    ' _key': 'certwise-theme/certwise/base-widgets/sliding-pane'
};
export default css;
